import type { Component } from "svelte";
import type { RowPreview } from "#lib/products/rows.ts";

export type SceneLoader = () => Promise<{ default: Component }>;

export const SCENES: Partial<Record<RowPreview, SceneLoader>> = {
  charts: () => import("./ChartsScene.svelte"),
  pulse: () => import("./PulseScene.svelte"),
  findings: () => import("./FindingsScene.svelte"),
  impact: () => import("./EventImpactScene.svelte"),
  earning: () => import("./LevelsScene.svelte"),
  boosts: () => import("./BoostScene.svelte"),
  perks: () => import("./AchievementScene.svelte"),
  import: () => import("./ImportScene.svelte"),
  requests: () => import("./RoleScene.svelte"),
  "own-bot": () => import("./OwnBotScene.svelte"),
  team: () => import("./TeamScene.svelte"),
};
